import { Orientor, BasicLayout, OrientationMap } from '@1x2network/layout'
import { applySpecification, ContainerSpecification, createSprite, SpriteSpecification } from '@1x2network/pixi_assets'
import { SplashComponent } from '@1x2network/pixi_splash'
import { Container, IDestroyOptions, Sprite } from 'pixi.js'
import gsap from 'gsap'

export class AntebetAnimationLoop extends SplashComponent<AntebetLoopSpecification> {
    private orientor: Orientor<ContainerSpecification>
    private enabled: Sprite
    private disabled: Sprite
    private timeline?: gsap.core.Timeline

    constructor(options: { parent?: Container; layout: BasicLayout; spec: AntebetLoopSpecification }) {
        super(options)
        this.orientor = new Orientor({
            layout: options.layout,
            property: this.specification.orientation,
            onOrient: (active) => {
                applySpecification(this, active)
            },
        })
        this.enabled = createSprite({ spec: this.specification.enabled, parent: this })
        this.disabled = createSprite({ spec: this.specification.disabled, parent: this })
    }
    public show(): void {
        super.show()
        this.animate()
    }

    private animate(): void {
        let enabled = true
        this.timeline = gsap
            .timeline({ repeat: -1, yoyo: true })
            .to({}, { duration: 2 })
            .to([this.disabled.scale, this.enabled.scale], {
                x: '*=0.90',
                y: '*=0.90',
                duration: 0.1,
            })
            .call(() => {
                this.disabled.visible = !enabled
                this.enabled.visible = enabled
                enabled = !enabled
            })
    }

    public hide(): void {
        super.hide()
        this.timeline?.kill()
    }

    public destroy(options?: IDestroyOptions | boolean): void {
        this.orientor.disconnect()
        super.destroy(options)
    }
}

export interface AntebetLoopSpecification extends ContainerSpecification {
    orientation: OrientationMap<ContainerSpecification>
    enabled: SpriteSpecification
    disabled: SpriteSpecification
}
